module.exports = __webpack_public_path__ + "img/Beymen.38e77118.png";